import {
  type ChassisCodeListId,
  MAKE_PACKAGE_IDS,
  MAKE_PACKAGES,
  type MainGroupListId,
  type MakePackageId,
} from "@bt/parts-core";

/**
 * Make packages: the ready-made main groups and chassis code lists a garage can load, named after
 * the makers' home towns (ADR 0014). Loading one changes what is offered, never what
 * an existing tag or chassis code means. The packages themselves (MAKE_PACKAGES) are data in
 * @bt/parts-core; which ones a garage loads is the garage's setting, kept here.
 */

/** What a garage has loaded until a garage admin chooses. */
export const DEFAULT_MAKE_PACKAGES: readonly MakePackageId[] = ["munich"];

/**
 * A garage's loaded packages from its stored setting: known ids only, each once, in a fixed
 * order. The default only when there is no list at all; a garage that unloaded everything keeps
 * none.
 */
export function makePackagesOf(value: unknown): MakePackageId[] {
  if (!Array.isArray(value)) return [...DEFAULT_MAKE_PACKAGES];
  return MAKE_PACKAGE_IDS.filter((id) => value.includes(id));
}

/** The main-group lists the packages offer, each once. */
export function mainGroupListsOf(packages: readonly MakePackageId[]): MainGroupListId[] {
  return [...new Set(packages.map((id) => MAKE_PACKAGES[id].mainGroups))];
}

/** The chassis code lists the packages offer, package by package. */
export function chassisCodeListsOf(packages: readonly MakePackageId[]): ChassisCodeListId[] {
  return packages.flatMap((id) => MAKE_PACKAGES[id].chassisCodeLists);
}
